import React, { Component } from 'react';
import { APP_URL_API } from '../../../setup/configs';
import Input from '../../../ui/input/Input';
import axios from 'axios';
import Header from '../../common/Header';
import Modal from '../../../ui/modal/Modal';
import AuthService from '../../auth/AuthService';
import withAuth from '../../auth/withAuth';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class AlertMessage extends Component {
	constructor(props) {
        super(props);
        this.state = {
            alertTitle: '',
            editorState: EditorState.createEmpty(),
            dataSaved: false,
            showModal: false,
            alertId: null,
            alertIsActivated: false
        }
    }
    componentDidMount() {
    	this.fetchData();
    }
    fetchData() {
    	const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'alertMessage/latestNotDeactivated';

        this.serverRequest =
            axios
                .get(url, {headers: config})
                .then(function(result) {
                	if(result.data) {
                		this.setState({
	                		alertTitle: result.data.data.title,
	                		alertId: result.data.data.id,
	                		editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(result.data.data.message))),
	                		alertIsActivated: result.data.data.publish_begin_at === "" ? false : true
                		})
                	} else {
                		this.setState({
		                	alertId: null,
		                	alertIsActivated: false
		                })
                	}
                }.bind(this))
    }

	onChange = (e) => {
	    const name= e.target.name;
	    const value= e.target.value;

	    this.setState({
	      [name]: value,
	      dataSaved: false
	    });
	}
	onHandleSave = () => {
		if(this.state.alertTitle==="") {
			this.setState({
		        showModal: true
		      });
			return false;
		}
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};

        const data = {};
        const contentState = this.state.editorState.getCurrentContent();
        data.title = this.state.alertTitle;
        data.message = JSON.stringify(convertToRaw(contentState));

        if(this.state.alertId>0) {
        	const url = APP_URL_API + 'alertMessage/' +this.state.alertId;
        	data._method = "patch";
        	this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                	this.setState({
                		dataSaved: true,
                	}, this.fetchData())
                }.bind(this))
        } else {
        	const url = APP_URL_API + 'alertMessage';
        	this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                	this.setState({
                		dataSaved: true,
                	}, this.fetchData())
                }.bind(this))
        }
	}

	onHandleActivate = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};

        const data = {};
        data._method = "patch";

        const url = APP_URL_API + 'alertMessage/' + this.state.alertId + '/activate';
        	this.serverRequest =
            axios
                .patch(url, data, {headers: config})
                .then(function(result) {
                	this.fetchData();
                }.bind(this))
	}

	onHandleDeactivate = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};

        const data = {};
        data._method = "patch";

        const url = APP_URL_API + 'alertMessage/' + this.state.alertId + '/deactivate';
        	this.serverRequest =
            axios
                .patch(url, data, {headers: config})
                .then(function(result) {
                	this.fetchData();
                }.bind(this))
	}

	onEditorStateChange: Function = (editorState) => {
	    this.setState({
	      editorState,
	      dataSaved: false
	    });
	};

	render() {
		return(
			<div>
				<Header user={this.props.user} history={this.props.history}>
	              {this.props.user.type === 'admin' && <nav className="navigation">
	                <ul className="navigation__list">
	                  <li className="navigation__listitem"><a href="/admin/organizations/">Oversigt</a></li>
	                  <li className="navigation__listitem"><a href="/admin/organization/create">Opret</a></li>
	                  <li className="navigation__listitem active"><a href="/admin/organizations/settings">Indstillinger</a></li>
	                </ul>
	              </nav>}
	            </Header>

	            <ul className="navigation__list navigation__list--settings">
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/">Årsoversigt</a></li>
	            	<li className="navigation__listitem--small"><u>Tilsynsmeddelelse</u></li>
					<li className="navigation__listitem--small"><a href="/admin/organizations/settings/alert-info/">Informationsmeddelelse</a></li>
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/mail/">Mailafsendelse</a></li>
					<li className="navigation__listitem--small"><a href="/admin/organizations/settings/administrators/">Brugerstyring</a></li>
            	</ul>

	            <div className="content-wrapper">
	                    <div style={{margin: '2em 0'}}>
		                    <h3 className="list-header">Tilsynsmeddelelse</h3>
	                    </div>
	                    <div style={{margin: '2em 0'}}>
	                    	<Input placeholder="Intern overskrift til tilsynsmeddelelse" type="text" name="alertTitle" value={this.state.alertTitle} onChange={this.onChange} />
	                    </div>
	                    <div style={{margin: '2em 0'}} className="editor">
	                    	<div>Tekst til tilsynsmeddelelse</div>
	                    	<Editor editorState={this.state.editorState} onEditorStateChange={this.onEditorStateChange} />
	                    </div>
	                    <div style={{margin: '2em 0'}}>
	                    	<button className="button ocean" onClick={this.onHandleSave} disabled={this.state.dataSaved}>Gem</button>
	                    	{this.state.alertId>0 &&
	                    		<ToggleButton alertIsActivated={this.state.alertIsActivated} onHandleActivate={this.onHandleActivate} onHandleDeactivate={this.onHandleDeactivate} />
	                    			 }
	                    </div>
	                    {this.state.dataSaved && <div className="savedMessage">Indhold er gemt</div>}
	            </div>

	            <Modal visible={this.state.showModal}>
	            	<p>Overskrift skal udfyldes</p>
	            	<div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
	                	<button type="button" className="button" onClick={() => this.setState({showModal: false})}>Ok</button>
	            	</div>
	          	</Modal>
	        </div>
	    )
	}
}

const ToggleButton = (props) => {
	if(props.alertIsActivated) {
		return(<button className="button ocean" onClick={() => { if (window.confirm('Bemærk, at du er ved at fjerne tilsynsmeddelelsen på Trossamfundsregistrets brugerside.')) props.onHandleDeactivate()}} style={{float: 'right'}}>Deaktivér</button>)
	} else {
		return(<button className="button ocean" onClick={() => { if (window.confirm('Bemærk, at du er ved at udsende tilsynsmeddelelsen på Trossamfundsregistrets brugerside.')) props.onHandleActivate()}} style={{float: 'right'}}>Aktivér</button>)
	}
}

export default withAuth(AlertMessage);


// WEBPACK FOOTER //
// ./src/modules/admin/organization/AlertMessage.js